import React from 'react';
import { Label } from '@qred/components-library';
import useTranslate from '~/hooks/useTranslate';

const PayoutAccountLabel = () => {
  const translate = useTranslate();

  return (
    <Label size={'lg'} data-record>
      {translate('OnboardingOffer.PayoutAccountLabel')}
    </Label>
  );
};

export default PayoutAccountLabel;
